/**
 * @generated SignedSource<<d1bc922b0d3d1335497708dfcca5e4ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateProjectStageInput = {
  name: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateProjectStageMutation$variables = {
  input: CreateProjectStageInput;
};
export type CreateProjectStageMutation$data = {
  readonly createProjectStage: {
    readonly projectStageEdge: {
      readonly node: {
        readonly __typename: string;
        readonly id: string;
        readonly name: string | null;
        readonly sortOrder: number | null;
      } | null;
    } | null;
  } | null;
};
export type CreateProjectStageMutation = {
  variables: CreateProjectStageMutation$variables;
  response: CreateProjectStageMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateProjectStagePayload",
    "kind": "LinkedField",
    "name": "createProjectStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectStageTypeEdge",
        "kind": "LinkedField",
        "name": "projectStageEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sortOrder",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateProjectStageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateProjectStageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "85b021355e5b7f6726c243ce7906f23a",
    "id": null,
    "metadata": {},
    "name": "CreateProjectStageMutation",
    "operationKind": "mutation",
    "text": "mutation CreateProjectStageMutation(\n  $input: CreateProjectStageInput!\n) {\n  createProjectStage(input: $input) {\n    projectStageEdge {\n      node {\n        __typename\n        id\n        name\n        sortOrder\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0bbf430f3d5e9f7e97c3a11c405cc73e";

export default node;
